import type { FERBACPermissions } from '@dfg/brahma-types';
import { ContextAction } from '../types';
import type { RBACPermissionsAction } from './types';

export const permissionReducer = (
  state: FERBACPermissions | undefined,
  action: RBACPermissionsAction
): FERBACPermissions | undefined => {
  switch (action.type) {
    case ContextAction.setPermissions:
      return { ...state, ...action.payload };
    case ContextAction.resetPermissions:
      return undefined;
    default:
      return state;
  }
};
